import { raise } from "@leavy/utils";
const raiseNotYetInitialized = (propertyName) => raise(new Error(`Property "${propertyName}" of the GlobalApplicationContext is not yet initialized!`));
const raiseAlreadyInitialized = (propertyName) => raise(new Error(`Property "${propertyName}" of the GlobalApplicationContext is already initialized!`));
/**
 * Global context of the application.
 * <br>Use the `default` accessor present on the constructor to access the singleton.
 */
export class GlobalApplicationContext {
    constructor() { }
    static get default() {
        return this._default = this._default ?? new GlobalApplicationContext();
    }
    /**
     * Get the instance of the Fastoche application
     */
    get fastoche() {
        return this._fastoche ?? raiseNotYetInitialized("fastoche");
    }
    set fastoche(value) {
        if (this._fastoche)
            raiseAlreadyInitialized("fastoche");
        this._fastoche = value;
    }
    /**
     * Get the instance of the Vue.js root component
     */
    get vue() {
        return this._vue ?? raiseNotYetInitialized("vue");
    }
    set vue(value) {
        if (this._vue)
            raiseAlreadyInitialized("vue");
        this._vue = value;
    }
    /**
     * Get the instance of the Vue.js router
     */
    get router() {
        return this._router ?? raiseNotYetInitialized("router");
    }
    set router(value) {
        if (this._router)
            raiseAlreadyInitialized("router");
        this._router = value;
    }
}
export function getGlobalApplicationContext() {
    return GlobalApplicationContext.default;
}
//# sourceMappingURL=GlobalApplicationContext.js.map